import { FontEmphasis } from '@prisjakt/ui/text';
import React from 'react';
import { ShippingCollection } from 'src/types';
import { getDeliveryDays, ShippingType } from './utils';
import { ShowOnMediumUp, CaptionText } from './styles';

interface IDeliveryTimeProps {
  shipping: ShippingCollection;
}

export const DeliveryTime: React.FC<IDeliveryTimeProps> = props => {
  const { shipping } = props;
  const expectedDeliveryDays = getDeliveryDays(shipping, ShippingType.CHEAPEST);

  return (
    <CaptionText emphasis={FontEmphasis.MEDIUM}>
      <ShowOnMediumUp>Förväntad leverans:</ShowOnMediumUp>
      {expectedDeliveryDays} dagar
    </CaptionText>
  );
};
